// Show/Hide the checkboxes for Advoc8 Managed Fields in Person Edit Page

function toggleSubscribedToField() {
  var $field = $(this).closest('.input-group').find("textarea, select, input:not(:checkbox, :hidden)");
  $field.prop('disabled', this.checked)
}

$(document).on("change", "input[name='person[subscribed_to_fields][]']", toggleSubscribedToField)
